module.exports = __webpack_public_path__ + "static/media/Tensorflow.b6e5ce3d.png";